import {
    CINCH_CAR_ACCOUNT_ID,
    CINCH_CAR_VIP_ALTERNATIVE_LOCATION_TEXT,
} from '@gumtree/shared/src/constants/cinch-car';
import { VipState } from './reducers';

export function selectPartnershipParams({ adDetails, displayAds, partnerships }: VipState) {
    const partnershipParams = {
        ...partnerships,
        outcode: displayAds?.config?.targeting?.outcode ? displayAds.config.targeting.outcode : '',
        title: adDetails.title,
        subArea: adDetails.subArea,
        adDetails,
    };
    if ('attributeGroups' in adDetails.attributes) {
        try {
            partnershipParams.mileageValue = adDetails?.attributes?.attributeGroups
                .map(({ attributes }) => attributes)
                .flat()
                .find(({ key }) => key === 'vehicle_mileage')?.value;
        } catch {
            // do nothing
        }
    }
    return partnershipParams;
}

export function selectState({
    adDetails,
    vhcData,
    baseConfig,
    mapDetails,
    userData,
    video,
    breadcrumbs,
    sellerSkills,
    sellerSkillsList,
    requestId,
    adSource,
    adReviews,
    qaPairs,
    otherServices,
    images,
    partnerships,
    sellerContactDetails,
    sellerRating,
    tabs,
    overview,
    postCall,
    similarAds,
}: VipState) {
    const isSellerCinchCar = partnerships?.accountId === CINCH_CAR_ACCOUNT_ID.toString();

    return {
        adDetails: {
            ...adDetails,
            address: isSellerCinchCar ? CINCH_CAR_VIP_ALTERNATIVE_LOCATION_TEXT : adDetails.address,
        },
        vhcData,
        baseConfig,
        mapDetails,
        breadcrumbs,
        sellerSkills: sellerSkills || [],
        sellerSkillsList: sellerSkillsList || [],
        requestId: requestId || '',
        adSource: adSource || '',
        adReviews: adReviews || [],
        qaPairs: qaPairs || [],
        otherServices: otherServices || [],
        userData,
        video,
        images,
        replyEmail: sellerContactDetails?.replyEmail,
        sellerContactDetails,
        isSellerCinchCar,
        tabs,
        overview,
        scoreAndReviews: {
            average: sellerRating.average || 0,
            total: sellerRating.total || 0,
            topTips: sellerRating.topTips || '',
            bottomTips: sellerRating.bottomTips || '',
            type: sellerRating.type || '',
        },
        postCall,
        similarAds,
    };
}
